function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function groupedOptionsToArray(groupedOptions) {
  return Object.keys(groupedOptions).reduce(function (arr, optgroup) {
    var optgroupOptions = groupedOptions[optgroup];
    return arr.concat( // @ts-ignore
    optgroupOptions.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        __optgroup: optgroup
      });
    }));
  }, []);
}

export function normalizeOptions(options) {
  if (options) {
    if (Array.isArray(options)) {
      return options;
    } else {
      return groupedOptionsToArray(options);
    }
  }

  return [];
}
export var expandValue = function expandValue(value, props) {
  if (!props.options) return value;
  var normalizedOptions = normalizeOptions(props.options);

  for (var i = 0; i < normalizedOptions.length; i++) {
    // @ts-ignore
    if (String(normalizedOptions[i][props.valueKey]) === String(value[props.valueKey])) {
      return normalizedOptions[i];
    }
  }

  return value;
};